import axios from "axios";

export type ActivityLogActionType =
	| "view"
	| "click"
	| "create"
	| "update"
	| "delete"
	| "auth";

export type TrackActivityPayload = {
	module: string;
	action: string;
	actionType: ActivityLogActionType;
	userId?: string | null;
	companyId?: string | null;
	entityType?: string | null;
	entityId?: string | null;
	metadata?: Record<string, any> | null;
	ipAddress?: string | null;
	userAgent?: string | null;
};

export const trackActivity = async (
	payload: TrackActivityPayload,
	config?: Record<string, any>,
) => {
	try {
		const res: any = await axios.post(
			"/activity-tracker",
			payload,
			{ excludeInterceptor: true, ...(config || {}) } as any,
		);
		return res?.data ? res.data : {};
	} catch (e: any) {
		return e?.response?.data ? e.response.data : e;
	}
};

export const getActivitiesByModule = async ({
	module,
	companyId,
	limit = 100,
}: {
	module: string;
	companyId?: string;
	limit?: number;
}) => {
	try {
		const params = new URLSearchParams();
		params.append("module", module);
		if (companyId) params.append("companyId", companyId);
		if (limit) params.append("limit", limit.toString());

		const res: any = await axios.get(
			`/activity-tracker?${params.toString()}`,
		);
		return res?.data ? res.data : [];
	} catch (e: any) {
		console.error("Error fetching activities:", e);
		return [];
	}
};
